export default __webpack_public_path__ + "static/media/FacebookH.bb8bd5f0.svg";